module.exports = __webpack_public_path__ + "static/img/toLoginIcon.509e9ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/toLoginIcon.png
// module id = Xl4T
// module chunks = 2